import '.kh{display:inline-block;}.ssr-plugin'
import '.hv{margin-top:1.5rem;}.ssr-plugin'
import '.bv{font-size:0.875rem;}.ssr-plugin'
import '.ki{color:var(--palette-blue-500);}.ssr-plugin'
import '.j1{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="kh hv bv ki j1"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
